<template>
  <el-header
    height="60px"
    class="layout-header">
    <div class="layout-header-title">质量管理平台</div>
    <div
      ref="menuWrap"
      class="header-menu">
      <el-menu
        :default-active="active"
        background-color="#2e353f"
        text-color="#fff"
        active-text-color="#ffd04b"
        mode="horizontal">
        <el-menu-item
          v-for="item in menuList"
          :key="item.activePath"
          style="padding: 0 8px"
          :index="item.activePath + ''"
          @click="openUrl(item.funcAddress)">{{ item.menuName }}</el-menu-item>
      </el-menu>
      <template v-if="menuDropdown.length > 0">
        <el-dropdown
          placement="bottom"
          size="medium">
          <i
            class="el-icon-more"
            :class="{ 'is-icon-more-active': isExtraActive }"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in menuDropdown"
              :key="item.activePath"
              :class="{'is-dropdown-item-active': active === item.activePath + ''}"
              class="custom-drop-item"
              @click.native="openUrl(item.funcAddress)">{{ item.menuName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>
    <div class="layout-header-user">
      <!-- <ent-apply-form v-if="userInfo.vendorId" /> -->
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{ userInfo.account }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">退出登陆</el-dropdown-item>
          <!-- <el-dropdown-item
            v-if="permission.ENT"
            @click.native="entInfo">
            企业信息
          </el-dropdown-item>
          <el-dropdown-item
            v-if="permission.LAB"
            @click.native="labInfo">
            实验室信息
          </el-dropdown-item>
          <el-dropdown-item
            v-if="permission.AGENCY"
            @click.native="agencyInfo">
            机构信息
          </el-dropdown-item> -->
          <el-dropdown-item @click.native="updatePwd">修改密码</el-dropdown-item>
          <el-dropdown-item
            v-if="permission.LVL1_ADMIN"
            @click.native="setEntPic">图文信息设置</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <password-modal
        ref="modal"
        :account="userInfo.account" />
    </div>
    <ent-pic-modal ref="ent" />
  </el-header>
</template>
<script>
import { mapState } from 'vuex'
import EntPicModal from './ent-pic-modal.vue'
import PasswordModal from './password-modal.vue'
// import GuideModal from './busi/guide-modal.vue'
// import EntApplyForm from './busi/ent-apply-form.vue'
import { navigateToLogin } from '../../utils/navigateToLogin'
import throttle from 'lodash/throttle'
export default {
  name: 'LayoutHeader',
  components: { PasswordModal, EntPicModal },
  data() {
    return { menuWidthList: [], menuList: [], menuDropdown: [] }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission,
      menu: (state) => state.account.menu
    }),
    active() {
      return this.$route.meta.activeTopPath + ''
    },
    isExtraActive({ menuDropdown, active }) {
      return menuDropdown.map(i => i.activePath + '').includes(active)
    }
  },
  mounted() {
    if (this.userInfo.needChangePassword) {
      this.$refs.modal.forceUpdate()
    }
    this.menuList = this.menu
    setTimeout(() => {
      const menuWrap = this.$refs.menuWrap
      const menuItems = [...menuWrap.querySelectorAll('.el-menu-item')]
      menuItems.forEach(i => {
        console.dir(i.clientWidth)
        this.menuWidthList.push(i.clientWidth)
      })
      this.initMenu()
      window.addEventListener('resize', throttle(this.initMenu, 100))
    }, 20)
  },
  methods: {
    initMenu() {
      const menuWrapWidth = this.$refs.menuWrap.clientWidth
      const menuWidthList = this.menuWidthList
      console.dir(menuWrapWidth, menuWidthList)
      const size = menuWidthList.length
      let menuWidth = 0
      let currentIndex = size - 1
      for (let index = 0; index < size; index++) {
        menuWidth += menuWidthList[index]
        console.log(index, menuWidth, menuWrapWidth)
        if (menuWidth + 22 >= menuWrapWidth) {
          currentIndex = index - 1
          break
        }
      }
      console.log('currentIndex', currentIndex)
      // currentIndex = currentIndex >= size - 1 ? currentIndex : (currentIndex - 1 > -1 ? currentIndex - 1 : currentIndex)
      currentIndex = currentIndex > -1 ? currentIndex : currentIndex - 1
      console.log('currentIndex', currentIndex)
      this.menuList = this.menu.slice(0, currentIndex + 1)
      this.menuDropdown = this.menu.slice(currentIndex + 1)
      console.log(this.menuList, this.menuDropdown)
    },
    openUrl(url) {
      this.$router.push(url)
    },
    logout() {
      this.$store.dispatch('account/logout', {
        payload: {},
        success: () => {
          // this.$router.push({ path: '/login' })
          navigateToLogin()
        }
      })
    },
    setEntPic() {
      this.$refs.ent.getkeyvaluebykey()
    },
    // entInfo() {
    //   this.$router.push('/vendordetail?vendorId=' + this.userInfo.orgId)
    // },
    // labInfo() {
    //   this.$router.push('/labdetail?labId=' + this.userInfo.orgId)
    // },
    // agencyInfo() {
    //   this.$router.push('/agencydetail?seaportId=' + this.userInfo.orgId)
    // },
    updatePwd() {
      this.$refs.modal.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus" scoped>
.layout-header {
  padding: 0 20px;
  display: flex;
  align-items: center;
  background: #2e353f;
  // justify-content: space-between;
  box-shadow: 0 0 6px rgba(0, 21, 41, 0.2);
  z-index: 9;

  .layout-header-title {
    font-size: 21px;
    font-weight: 900;
    // margin-left: 20px;
    letter-spacing: 3px;
    color: #fff;
  }

  .header-menu {
    flex: 1;
    margin:0 36px;
    display: flex
    align-items: center
    .el-menu {
      display: inline-block;
      vertical-align: top;
    }
    .el-menu-item {
      font-size 16px;
      font-weight bold;
      padding: 0 6px !important
    }

    .el-icon-more {
      margin-left: 6px
      color: #fff
      font-size: 16px;
      cursor pointer

      &.is-icon-more-active {
        font-weight: bold
        color: #ffd04b
      }
    }

  }
  .layout-header-user {
    display: flex;
    align-items: center;

    .el-dropdown-link {
      cursor: pointer;
      color: #fff;
    }
  }
}
/deep/.el-dropdown-menu__item {
      font-size: 16px !important;

      &.is-dropdown-item-active {
        font-weight: bold
        color: #ffd04b
      }
    }
</style>
